/**
 * App-level provider composition.
 *
 * Susurro is guest-first (the identity belongs to the device, no account). The
 * boot resources are the lingui catalogue (i18n) and the chat engine
 * (E2E identity + blind relay + local-first persistence).
 */

import type { ParentComponent } from "solid-js";

import { I18nProvider } from "@/providers/i18n-provider";
import { ChatProvider } from "@/providers/chat-provider";
import { TypographyProvider } from "@/providers/typography-provider";
import { AccountProvider } from "@/providers/account-provider";
import { KernelProvider } from "@/providers/kernel-provider";

export const AppProviders: ParentComponent = (props) => (
  <I18nProvider>
    <TypographyProvider>
      <AccountProvider>
        <KernelProvider>
          <ChatProvider>{props.children}</ChatProvider>
        </KernelProvider>
      </AccountProvider>
    </TypographyProvider>
  </I18nProvider>
);
